<div>
  <span data-omni-qa="omni-dialog-date-change">{{
    date | date: 'EEE, MM/dd/yyyy'
  }}</span>
</div>
